import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Mail } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TIKTOK_URL = "https://www.tiktok.com/@drip4saisons";
const CONTACT_EMAIL = "drip4saisons@gmail.com";

const CONTENT = {
    cgv: {
        title: "Conditions Générales de Vente",
        sections: [
            {
                h: "1. Objet",
                p: "Les présentes Conditions Générales de Vente (CGV) régissent les ventes de paires de Crocs™ Spider-Man authentiques conclues sur le site DRIP4SAISONS entre Alama Bizenba, 105 rue Jean Voillot, 69100 Villeurbanne, France (ci-après « le Vendeur ») et tout client (ci-après « le Client »). Toute commande implique l'acceptation pleine et entière des présentes CGV.",
            },
            {
                h: "2. Produits",
                p: "Les produits proposés sont des paires de Crocs™ Spider-Man neuves et authentiques, présentées avec photos réelles, description et tailles disponibles. Les offres sont valables dans la limite des stocks disponibles.",
            },
            {
                h: "3. Prix",
                p: "Les prix sont indiqués en euros, toutes taxes comprises (TTC). La livraison est offerte à partir de 50 € d'achat ; en dessous, elle est facturée 2,99 €. Le Vendeur se réserve le droit de modifier ses prix à tout moment ; le prix applicable est celui affiché au moment de la commande.",
            },
            {
                h: "4. Commande",
                p: "Le Client choisit sa paire et sa taille, puis est redirigé vers la page de paiement sécurisée. La commande est définitive après validation du paiement. Une confirmation de commande est envoyée par e-mail à l'adresse indiquée lors du paiement.",
            },
            {
                h: "5. Paiement",
                p: "Le paiement s'effectue en une seule fois, par carte bancaire, via la plateforme sécurisée Stripe. Le débit est réalisé au moment de la validation de la commande. Aucune donnée bancaire n'est conservée par le Vendeur.",
            },
            {
                h: "6. Livraison",
                p: "Livraison sous 10 jours, en France et dans les pays proposés au paiement, à l'adresse indiquée par le Client. Elle est offerte dès 50 € d'achat et facturée 2,99 € en dessous. Un e-mail d'expédition est envoyé dès le départ du colis. En cas de retard anormal, le Client peut contacter le Vendeur à drip4saisons@gmail.com.",
            },
            {
                h: "7. Droit de rétractation",
                p: "Conformément aux articles L221-18 et suivants du Code de la consommation, le Client dispose de 14 jours à compter de la réception de sa commande pour exercer son droit de rétractation, sans avoir à justifier de motif. Pour l'exercer : écrire à drip4saisons@gmail.com en indiquant le numéro de commande. Le produit doit être retourné non porté, dans son état d'origine, étiquettes incluses. Les frais de retour sont à la charge du Client.",
            },
            {
                h: "8. Remboursements",
                p: "Après réception et vérification du retour, le remboursement est effectué via Stripe sur le moyen de paiement initial, dans un délai maximum de 14 jours. Le remboursement couvre le prix du produit. Les produits portés ou retournés hors délai ne sont pas repris, sauf défaut de fabrication.",
            },
            {
                h: "9. Garanties légales",
                p: "Le Client bénéficie de la garantie légale de conformité (articles L217-3 et suivants du Code de la consommation) pendant 2 ans, et de la garantie des vices cachés (articles 1641 et suivants du Code civil). En cas de produit défectueux ou non conforme : réexpédition d'une paire neuve ou remboursement intégral, au choix du Client.",
            },
            {
                h: "10. Responsabilité",
                p: "Le Vendeur ne saurait être tenu responsable des dommages résultant d'une mauvaise utilisation du produit, ni des retards de livraison imputables au transporteur ou à un cas de force majeure.",
            },
            {
                h: "11. Propriété intellectuelle",
                p: "Les produits vendus sont des articles authentiques ; le Vendeur n'est pas affilié à Marvel, Disney ou Crocs™. L'ensemble du contenu du site (textes, photos, logo) est la propriété du Vendeur et ne peut être reproduit sans autorisation.",
            },
            {
                h: "12. Données personnelles",
                p: "Les données collectées (nom, adresse, e-mail) servent exclusivement au traitement et à l'expédition des commandes, conformément au RGPD. Droits d'accès, de rectification et de suppression : drip4saisons@gmail.com.",
            },
            {
                h: "13. Litiges et médiation",
                p: "Les présentes CGV sont soumises au droit français. En cas de litige, le Client peut saisir gratuitement le médiateur de la consommation compétent, ou présenter sa réclamation sur la plateforme européenne de règlement en ligne des litiges. À défaut de résolution amiable, les tribunaux français sont compétents.",
            },
            {
                h: "14. Contact",
                p: "DRIP4SAISONS — Alama Bizenba, 105 rue Jean Voillot, 69100 Villeurbanne, France — drip4saisons@gmail.com. CGV mises à jour le 24 octobre 2026.",
            },
        ],
    },
    "mentions-legales": {
        title: "Mentions légales",
        sections: [
            {
                h: "Éditeur du site",
                p: "DRIP4SAISONS — revente de Spider-Web. Exploitant : Drip4saisons (Alama Bizenba), 105 rue Jean Voillot, 69100 Villeurbanne, France. Contact : drip4saisons@gmail.com.",
            },
            {
                h: "Directeur de la publication",
                p: "Drip4saisons (Alama Bizenba).",
            },
            {
                h: "Hébergement",
                p: "Site hébergé par Emergent (emergent.sh). Paiements traités par Stripe.",
            },
            {
                h: "Propriété intellectuelle",
                p: "Revente de produits authentiques, non affiliée à Marvel, Disney ou Crocs™. Les marques et personnages cités appartiennent à leurs détenteurs respectifs. Les photos des produits sont réelles et propres à la boutique.",
            },
            {
                h: "Données personnelles",
                p: "Les informations collectées lors d'une commande (nom, adresse, e-mail) servent uniquement à l'expédition et au suivi de ta commande. Elles ne sont ni revendues ni partagées. Pour toute demande d'accès ou de suppression : drip4saisons@gmail.com.",
            },
        ],
    },
    "livraison-retours": {
        title: "Livraison & retours",
        sections: [
            {
                h: "Livraison",
                p: "Livraison offerte dès 50 € d'achat (2,99 € en dessous), partout en France et dans les pays proposés au moment du paiement. Délai annoncé : 10 jours. Tu reçois un e-mail dès que ta paire est expédiée.",
            },
            {
                h: "Retours",
                p: "Tu as 14 jours après réception pour retourner ta paire si elle ne te convient pas, à condition qu'elle soit non portée et dans son état d'origine (étiquettes Marvel incluses). Écris d'abord à drip4saisons@gmail.com pour recevoir l'adresse de retour. Les frais de retour sont à ta charge.",
            },
            {
                h: "Colis endommagé ou erreur de taille",
                p: "Si le colis arrive endommagé ou si tu as reçu une autre taille que celle commandée, écris à drip4saisons@gmail.com avec une photo : on te réexpédie la bonne paire ou on te rembourse intégralement.",
            },
        ],
    },
    remboursement: {
        title: "Politique de remboursement",
        sections: [
            {
                h: "Quand suis-je remboursé ?",
                p: "Remboursement intégral si tu retournes ta paire dans les 14 jours suivant la réception, non portée et en parfait état. Remboursement également en cas de produit défectueux ou d'erreur de notre part.",
            },
            {
                h: "Comment ça marche ?",
                p: "Une fois ton retour reçu et vérifié, le remboursement est déclenché via Stripe sur ton moyen de paiement initial. Il apparaît sur ton compte sous 5 à 10 jours ouvrés selon ta banque.",
            },
            {
                h: "Produits exclus",
                p: "Les paires portées, sans étiquettes d'origine, ou retournées après le délai de 14 jours ne peuvent pas être reprises, sauf défaut de fabrication.",
            },
            {
                h: "Une question ?",
                p: "Écris à drip4saisons@gmail.com — réponse sous 24 à 48H.",
            },
        ],
    },
    contact: {
        title: "Contact",
        sections: [
            {
                h: "Par e-mail",
                p: "Pour toute question sur une commande, une taille ou un retour : drip4saisons@gmail.com. Réponse sous 24 à 48H.",
            },
            {
                h: "Sur TikTok",
                p: "Suis les coulisses et les prochains coloris sur TikTok : @drip4saisons.",
            },
        ],
    },
};

export default function InfosPage() {
    const { slug } = useParams();
    const page = CONTENT[slug];

    return (
        <div className="min-h-screen bg-spidey-bg flex flex-col">
            <Navbar />
            <main className="flex-1 max-w-3xl mx-auto px-5 sm:px-8 pt-32 pb-20 w-full">
                {!page ? (
                    <div className="text-center pt-16">
                        <h1 className="font-display uppercase text-3xl text-white">Page introuvable</h1>
                        <Link to="/" className="mt-6 inline-block text-sm text-spidey-neon hover:underline">
                            ← Retour à la boutique
                        </Link>
                    </div>
                ) : (
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    >
                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 text-xs font-mono-brand uppercase tracking-[0.2em] text-zinc-500 hover:text-spidey-neon transition-colors"
                            data-testid="infos-back-link"
                        >
                            <ArrowLeft size={14} />
                            Boutique
                        </Link>
                        <h1 className="mt-5 font-display uppercase text-3xl sm:text-4xl text-white tracking-tight" data-testid="infos-page-title">
                            {page.title}
                        </h1>
                        <div className="mt-10 space-y-9">
                            {page.sections.map((s) => (
                                <section key={s.h}>
                                    <h2 className="text-lg font-bold text-white">{s.h}</h2>
                                    <p className="mt-2.5 text-zinc-400 leading-relaxed">{s.p}</p>
                                </section>
                            ))}
                            {slug === "contact" && (
                                <div className="flex flex-wrap gap-3 pt-2">
                                    <a
                                        href={`mailto:${CONTACT_EMAIL}`}
                                        className="inline-flex items-center gap-2 bg-spidey-red hover:bg-spidey-neon text-white text-sm font-bold uppercase tracking-wider px-6 py-3 rounded-full transition-all hover:shadow-[0_0_25px_rgba(230,0,38,0.5)]"
                                        data-testid="contact-email-button"
                                    >
                                        <Mail size={15} />
                                        Nous écrire
                                    </a>
                                    <a
                                        href={TIKTOK_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-flex items-center gap-2 border border-zinc-700 hover:border-spidey-red text-zinc-300 hover:text-white text-sm font-bold uppercase tracking-wider px-6 py-3 rounded-full transition-all"
                                        data-testid="contact-tiktok-button"
                                    >
                                        TikTok @drip4saisons
                                    </a>
                                </div>
                            )}
                        </div>
                    </motion.div>
                )}
            </main>
            <Footer />
        </div>
    );
}
